import React from 'react';

import { PageNavigation } from './PageNavigation';
import { PageSizePicker } from './PageSizePicker';
import { ViewStats } from './ViewStats';

import styles from './TablePagination.module.scss';

export interface ITablePaginationProps {}

export const TablePagination: React.FC<ITablePaginationProps> = () => {
    return (
        <div className={styles.paginationContainer}>
            <div className={styles.wrapper}>
                <PageNavigation />
                <ViewStats />
            </div>
            <PageSizePicker />
        </div>
    );
};
